import { createAction } from 'redux-actions';

export const fetchMoreDeviations = createAction(
  'STASH.FETCH_MORE_DEVIATIONS',
  (streamId: string) => ({ streamId })
);

export const fetchMoreSubfolders = createAction(
  'STASH.FETCH_MORE_SUBFOLDERS',
  (streamId: string) => ({ streamId })
);
